import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';

@Component({
  selector: 'app-details-page-header-placeholder',
  templateUrl: './details-page-header-placeholder.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, RktIconComponent],
})
export class DetailsPageHeaderPlaceholderComponent {
  @Input() pageReturnURL!: string;

  @Input() withStatus = true;
}
